<template>
  <div class="generate-pdfs-progress">
    <span v-if="generateProgress == 0">
      Les PDFs seront générés prochainement !
    </span>
    <span v-else-if="generateProgress == -1" class="text-danger">
      Les PDFs n'ont pas pu être générés ! <br />
      Veuillez contacter l'administrateur.
    </span>
    <span v-else class="text-info">
      Les PDFs sont en cours de génération !
    </span>
    <b-progress v-if="generateProgress > 0" :max="100" show-progress>
      <b-progress-bar
        variant="dark"
        :value="parseInt(generateProgress * 100)"
        :label="`${parseInt(generateProgress * 100)}%`"
      />
    </b-progress>
  </div>
</template>

<script>
export default {
  props: ["generateProgress"],
};
</script>
